export function formatKr(n: number): string {
  return `${n.toLocaleString("nb-NO")} kr`;
}

export function resolveScreenBand(
  bands: { max: number; label: string; amount: number }[],
  hours: number,
): { label: string; amount: number } {
  return bands.find((b) => hours <= b.max) ?? bands[bands.length - 1]!;
}
